import { PARAMS, FORMAS_PAGAMENTO } from '../config/parametrosCrediario';

export function taxaMensal(taxaAno) {
  return Math.pow(1 + taxaAno, 1 / 12) - 1;
}

// Fator de valor presente médio de uma parcela (anuidade dividida por N).
// N = 0 (à vista) retorna 1 (sem deságio).
export function fatorVP(n, taxaMes) {
  if (n <= 0 || taxaMes <= 0) return 1;
  return (1 - Math.pow(1 + taxaMes, -n)) / taxaMes / n;
}

export function markupCategoria(categoria) {
  return categoria === 'moveis' ? PARAMS.markupMoveis : PARAMS.markupEletro;
}

// Preço à vista padrão: custo médio + margem de lucro da categoria.
export function precoAvistaPadrao(custo, categoria) {
  return custo * (1 + markupCategoria(categoria));
}

// Cartão de crédito em 1x segue a regra do à vista (preço e limite do gerente).
export function ehAvista(forma, n) {
  return forma === 'avista' || n <= 0 || (forma === 'cartao' && n <= 1);
}

// Preço sugerido para a condição de venda: à vista padrão + juros do "empréstimo" ao
// cliente pelo prazo das parcelas (e inadimplência, no crediário). Valor presente das
// parcelas descontado à taxa da modalidade = preço à vista padrão.
export function precoSugerido({ custo, categoria, forma, n }) {
  const avista = precoAvistaPadrao(custo, categoria);
  if (ehAvista(forma, n)) return avista;
  const { taxaAno, inadimplencia } = FORMAS_PAGAMENTO[forma];
  return avista / (fatorVP(n, taxaMensal(taxaAno)) * (1 - inadimplencia));
}

// Classifica o preço solicitado:
//   'viavel'   — preço ≥ sugerido
//   'gerente'  — abaixo do sugerido, mas dentro do que o gerente pode liberar
//                (no crediário o gerente não libera desconto, então não existe essa faixa)
//   'inviavel' — abaixo do limite do gerente (só com justificativa: avaria, estoque antigo etc.)
export function avaliarPreco({ custo, categoria, forma, n, precoSolicitado }) {
  const sugerido = precoSugerido({ custo, categoria, forma, n });
  const parcelado = !ehAvista(forma, n);
  let precoMinimoGerente;
  if (parcelado) {
    precoMinimoGerente = sugerido * (1 - FORMAS_PAGAMENTO[forma].descMaxGerente);
  } else {
    const descMax = categoria === 'moveis' ? PARAMS.descMaxAvistaMoveis : PARAMS.descMaxAvistaEletro;
    precoMinimoGerente = custo * (1 + markupCategoria(categoria) - descMax);
  }
  // Compara em centavos para não cair em "gerente" por arredondamento do preço sugerido.
  const cent = v => Math.round(v * 100);
  let resultado = null;
  if (precoSolicitado > 0) {
    if (cent(precoSolicitado) >= cent(sugerido)) resultado = 'viavel';
    else if (cent(precoSolicitado) >= cent(precoMinimoGerente)) resultado = 'gerente';
    else resultado = 'inviavel';
  }
  const descontoPct = precoSolicitado > 0 ? 1 - precoSolicitado / sugerido : 0;
  return { precoSugerido: sugerido, precoMinimoGerente, resultado, descontoPct };
}
